import React, { Component, Suspense } from 'react';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import getInitialContentfulData from '../../utils/helpers/initialDataHelper';
import { defaultLangKey } from '../../constants/languages';
import Head from 'next/head';
import { getCdnImage } from '../../utils/ImageManager';
import {
  contentType,
  contentfulConstant,
} from '../../constants/global';
import SocialShare from '../../components/Brand/SocialShare/SocialScrollWrapper';
import DOMIdentifier from '../../utils/domIdentifier';
import Typography from '../../components/Generic/Typography';
import { renderSection, getVideoCard } from '../../utils/uiHelper';
import { Breadcrumb as GenericBreadcrumb, BreadcrumbItem } from '../../components/Generic/Breadcrumb';
import breadcrumbStyles from '../../components/Brand/Shared/Breadcrumb-tw-styles';
import breadcrumbI18n from '../../constants/messages/pt-BR';
import PageMetadata from '../../components/Generic/PageMetadata';
import PGDataLayer from '../../components/Generic/PGDataLayer/PGDataLayer';
import styles from '../../components/Brand/Article/article-tw-styles';
import config from '../../config';
import { postArticleCount } from '../../services/recommendedArticle';
import {
  ProductCarousel,
  ArticleCarousel,
} from '../../components/Brand/ProductCarousel';
import { SEOArticle } from '../../components/Brand/SEO';
import ThumbsUp from '../../components/Brand/WasThisHelpful/ThumbsUp';
import LazyLoad from 'react-lazy-load';

class ArticleDetail extends Component {
  static propTypes = {
    pageContext: PropTypes.oneOfType([PropTypes.object]).isRequired,
    articleData: PropTypes.oneOfType([PropTypes.object]).isRequired,
    router: PropTypes.oneOfType([PropTypes.object]).isRequired,
  };

  static async getInitialProps({ query }) {
    const slugFromQuery =
      query.slug ||
      (query.path
        ? query.path
          .split('?')[0]
          .split('/')
          .filter(Boolean)
          .pop()
        : null);

    let articleData = await getInitialContentfulData(
      contentfulConstant,
      contentType.articlePage,
      query.locale || defaultLangKey,
      { slug: slugFromQuery }
    );
    return {
      articleData: articleData.data,
      pageContext: query,
    };
  }

  constructor(props) {
    super(props);
    this.ArticleRef = React.createRef();
    this.relatedRef = React.createRef();
    this.faqRef = React.createRef();
    this.articleMainRef = React.createRef();
    this.relatedClassTimer = null;
    this.state = {
      thumbsUp: false,
      thumbsDown: false,
      isMobile: false,
      stopSidebarSticky: false,
    };
  }

  componentDidMount() {
    const { articleData } = this.props;
    const articleDetailData = articleData?.articleCollection?.items?.[0];
    const isMobile = window.innerWidth < 767;
    this.setState({
      isMobile: isMobile,
    });
    if (articleData && articleDetailData.variant !== 'VideoArticle') {
      window.addEventListener('resize', this.resetOnResize);
      window.addEventListener('scroll', this.scrollHandler);
      this.scrollHandler();
    }
    if (articleDetailData) {
      this.getRecommendedArticleCount();
      DOMIdentifier.addClassToBody(
        'article-details-page',
        `${articleDetailData.sys.id}-adp`
      );
      this.scheduleApplyRelatedArticleClasses();
      // Remove tabIndex from article content sections
      this.removeArticleTabIndex();
    }
  }

  removeArticleTabIndex = () => {
    const articleMain = document.querySelector('.article-main');
    if (articleMain) {
      const elementsWithTabIndex = articleMain.querySelectorAll('[tabindex="0"]');
      elementsWithTabIndex.forEach(el => {
        el.removeAttribute('tabindex');
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    const { articleData } = this.props;
    const articleDetailData = articleData.articleCollection.items[0];
    if (
      nextProps.articleData.articleCollection.items[0].sys.id !=
      articleDetailData.sys.id
    ) {
      // Remove added classes
      DOMIdentifier.removeClassToBody(
        'article-details-page',
        `${articleDetailData.sys.id}-adp`
      );
      // add new classes
      DOMIdentifier.addClassToBody(
        'article-details-page',
        `${nextProps.articleData.articleCollection.items[0].sys.id}-adp`
      );
    }
  }

  componentDidUpdate(prevProps) {
    const { pageContext } = this.props;
    if (pageContext.slug !== prevProps.pageContext.slug) {
      this.getRecommendedArticleCount();
    }
    this.scheduleApplyRelatedArticleClasses();
    this.removeArticleTabIndex();
  }

  componentWillUnmount() {
    const { articleData } = this.props;
    const articleDetailData = articleData?.articleCollection?.items?.[0];
    if (articleData && articleDetailData.variant !== 'VideoArticle') {
      window.removeEventListener('scroll', this.scrollHandler);
      window.removeEventListener('resize', this.resetOnResize);
    }
    if (articleDetailData) {
      DOMIdentifier.removeClassToBody(
        'article-details-page',
        `${articleDetailData.sys.id}-adp`
      );
    }
    if (this.relatedClassTimer) {
      clearTimeout(this.relatedClassTimer);
      this.relatedClassTimer = null;
    }
  }

  resetOnResize = () => {
    if (window.innerWidth < 850 && window.innerWidth > window.innerHeight) {
      window.removeEventListener('scroll', this.scrollHandler);
    } else if (window.innerWidth < 768 && window.innerHeight > 768) {
      window.addEventListener('scroll', this.scrollHandler);
    } else {
      window.addEventListener('scroll', this.scrollHandler);
    }
  };

  scrollHandler = () => {
    const { articleData } = this.props;
    const articleDetailData = articleData.articleCollection.items[0];
    if (
      articleData &&
      articleDetailData.variant !== 'VideoArticle' &&
      articleData.articleCollection &&
      articleData.articleCollection.items.length > 0
    ) {
      const bannerDiv = document.getElementById('bannerScroll');
      const viewsArticle = document.getElementById('views-article');
      const mobileStyle = document.getElementById('mobile-style');
      const heroTitlediv = document.getElementsByClassName('heroTitleId');
      const breadCrumbContainer = document.getElementsByClassName('breadcrumbContainer');
      const pageHeader = document.getElementById('page-header');
      
      // Guard against missing DOM elements
      if (!bannerDiv || !pageHeader || !breadCrumbContainer[0]) {
        return;
      }
      
      let scroll = window && Math.round(window.pageYOffset);
      let headerHeight = pageHeader.offsetHeight;
      let breadCrumbHeight = breadCrumbContainer[0].offsetHeight;
      let scr = -(scroll / 10) + (headerHeight + breadCrumbHeight);
      bannerDiv.style.backgroundPositionY = scr + 'px';
      if (
        window.innerWidth <= config.screenWidth.tabPhoneWidthEnd &&
        bannerDiv
      ) {
        if (scroll > bannerDiv.clientHeight - 200) {
          if (heroTitlediv[0]) {
            heroTitlediv[0].classList.add('resize-text-24');
          }
        } else {
          if (heroTitlediv[0]) {
            heroTitlediv[0].classList.remove('resize-text-24');
          }
          viewsArticle && viewsArticle.classList.remove('addclass');
        }
        if (scroll > bannerDiv.clientHeight - 35) {
          bannerDiv.classList.remove('transition-pt');
          bannerDiv.classList.add('Mobilebannersticky');
          if (mobileStyle) {
            mobileStyle.classList.add('mobile-sticky');
            mobileStyle.classList.add('mobile-article-overlay');
          }
        } else {
          bannerDiv.classList.add('transition-pt');
          bannerDiv.classList.remove('Mobilebannersticky');
          if (mobileStyle) {
            mobileStyle.classList.remove('mobile-sticky');
            mobileStyle.classList.remove('mobile-article-overlay');
          }
        }
      }
    }

    if (this.relatedRef.current && this.faqRef.current) {
      const sidebar = this.relatedRef.current;
      const faqTop =
        this.faqRef.current.getBoundingClientRect().top +
        window.pageYOffset;

      const scrollTop = window.pageYOffset;
      const headerOffset =
        document.getElementById('page-header')?.offsetHeight || 0;

      const sidebarBottom =
        scrollTop + headerOffset + sidebar.offsetHeight;

      if (sidebarBottom >= faqTop) {
        if (!this.state.stopSidebarSticky) {
          this.setState({ stopSidebarSticky: true });
        }
      } else {
        if (this.state.stopSidebarSticky) {
          this.setState({ stopSidebarSticky: false });
        }
      }
    }
  };

  getRecommendedArticleCount = async () => {
    const { articleData } = this.props;
    const article = articleData.articleCollection.items[0];
    const wasThisHelpful = window.sessionStorage.getItem(
      'wasThisHelpfulSession' + article.sys.id
    );
    if (wasThisHelpful === 'thumbsUp') {
      this.setState({ thumbsUp: true, thumbsDown: false });
    }
    if (wasThisHelpful === 'thumbsDown') {
      this.setState({ thumbsDown: true, thumbsUp: false });
    }
  };

  recommendThisArticle = value => {
    const { articleData, pageContext } = this.props;
    const article = articleData.articleCollection.items[0];
    let typeToSend = 1;
    if (value === 'thumbsDown') {
      typeToSend = 0;
    }
    const data = {
      articleId: article.sys.id,
      brand: 'Pantene',
      locale: pageContext.locale,
      type: typeToSend,
    };
    postArticleCount(data).then(response => {
      if (response.data.code === 'SUCCESS') {
        window.sessionStorage.setItem(
          'wasThisHelpfulSession' + article.sys.id,
          value
        );
        if (value === 'thumbsUp') {
          this.setState({ thumbsUp: true, thumbsDown: false });
        }
        if (value === 'thumbsDown') {
          this.setState({ thumbsDown: true, thumbsUp: false });
        }
      }
    });
  };

  scheduleApplyRelatedArticleClasses = () => {
    if (this.relatedClassTimer) {
      clearTimeout(this.relatedClassTimer);
    }
    this.relatedClassTimer = setTimeout(() => {
      this.applyRelatedArticleClasses();
    }, 500);
  };

  applyRelatedArticleClasses = () => {
    if (!this.relatedRef || !this.relatedRef.current) {
      return;
    }

    const relatedRoot = this.relatedRef.current;
    const { articleData, pageContext } = this.props;
    const relatedItems =
      articleData?.articleCollection?.items?.[0]?.relatedArticlesCollection?.items || [];
    const locale = (pageContext?.locale || defaultLangKey).toLowerCase();

    const contentNodes = relatedRoot.querySelectorAll('.content');

    contentNodes.forEach((element, index) => {
      element.classList.add('related_article-content');
      // Add accessibility attributes for NVDA
      element.setAttribute('role', 'article');
      element.setAttribute('tabindex', '-1');

      const titleWrapperNode = element.querySelector('.titleWrapper');
      if (titleWrapperNode) {
        titleWrapperNode.remove();
      }

      const headerButtonNode = element.querySelector('button.header.no-underline');
      if (headerButtonNode) {
        headerButtonNode.remove();
      }

      const slide = element.closest('.slick-slide');
const slickIndex = parseInt(slide?.getAttribute('data-slick-index'), 10);

const realIndex =
  !Number.isNaN(slickIndex) && relatedItems.length
    ? ((slickIndex % relatedItems.length) + relatedItems.length) % relatedItems.length
    : index;

const itemData = relatedItems[realIndex] || {};
      const shortDescription =
        typeof itemData.shortDescription === 'string'
          ? itemData.shortDescription.trim()
          : '';

      const mediaLink =
        element.closest('.mediaWrapper')?.querySelector('a[href]') ||
        element.closest('[class*="related-product-wrapper"]')?.querySelector('.mediaWrapper a[href]');
     const itemSlug =
  typeof itemData.slug === 'string'
    ? itemData.slug.replace(/^\/+/, '')
    : '';

const ctaHref = itemSlug ? `/${locale}/${itemSlug}` : '#';
      const ctaLabel =
        (itemData.callToActions && itemData.callToActions[0] && itemData.callToActions[0].text) ||
        (locale === 'es' ? 'APRENDER MÁS' : 'APRENDER MAIS');

      let titleLink = element.querySelector('a[role="link"], a.event_internal_link');
      if (!titleLink && ctaHref) {
        titleLink = document.createElement('a');
      }
      if (titleLink) {
        titleLink.className = 'event_internal_link';
        titleLink.setAttribute('href', ctaHref);
        titleLink.setAttribute('target', '_self');
        titleLink.setAttribute('role', 'link');
      }
      const mediaWrapper =
        element.closest('.mediaWrapper') ||
        element.closest('[class*="related-product-wrapper"]')?.querySelector('.mediaWrapper');
      if (mediaWrapper) {
        let mediaImageLink = Array.from(mediaWrapper.children).find(
          child => child.tagName === 'A'
        );

        if (!mediaImageLink) {
          const imgNode =
            mediaWrapper.querySelector('img') ||
            mediaWrapper.querySelector('[data-id="productlistIMG"]');
          if (imgNode) {
            const imgContainer = imgNode.closest('[data-id="productlistIMG"]') || imgNode;
            mediaImageLink = document.createElement('a');
            mediaImageLink.setAttribute('data-pgaction-redirection', '0');
            imgContainer.parentNode.insertBefore(mediaImageLink, imgContainer);
            mediaImageLink.appendChild(imgContainer);
          }
        }

        if (mediaImageLink) {
          const hasImage = mediaImageLink.querySelector('img') || mediaImageLink.querySelector('[data-id="productlistIMG"]');
          if (!hasImage) {
            if (mediaImageLink.parentNode) {
              mediaImageLink.parentNode.removeChild(mediaImageLink);
            }
            mediaImageLink = null;
          } else {
            mediaImageLink.setAttribute('href', ctaHref);
            mediaImageLink.setAttribute('data-pgaction-redirection', '0');
            mediaImageLink.setAttribute('aria-label', 'Imagen - Produto relacionado');
            mediaImageLink.setAttribute('tabindex', '0');
            mediaImageLink.style.cursor = 'pointer';
            mediaImageLink.style.display = 'block';
            mediaImageLink.style.pointerEvents = 'auto';
            if (!mediaImageLink.hasAttribute('data-focus-scroll-attached')) {
              mediaImageLink.setAttribute('data-focus-scroll-attached', 'true');
              mediaImageLink.addEventListener('focus', function() {
                this.style.outline = '2px solid #d69f13';
                this.style.outlineOffset = '2px';
                const headerHeight = document.getElementById('page-header')?.offsetHeight || 0;
                const elementRect = this.getBoundingClientRect();
                const absoluteElementTop = elementRect.top + window.pageYOffset;
                const scrollPosition = absoluteElementTop - headerHeight - 50;
                window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
              });
              mediaImageLink.addEventListener('blur', function() {
                this.style.outline = '';
                this.style.outlineOffset = '';
              });
            }
          }
        }
      }

      const titleNode = element.querySelector(
        '.related_article-title, h3, .title, a[role="link"] > div, a.event_internal_link > div, a[role="link"], a.event_internal_link'
      );
      const fallbackTitle =
        typeof itemData.title === 'string' ? itemData.title.trim() : '';
      const domTitleText = titleNode?.textContent ? titleNode.textContent.trim() : '';
      const titleText = domTitleText || fallbackTitle;

      // Set aria-label for screen readers
      if (titleText) {
        element.setAttribute('aria-label', `Artigo relacionado: ${titleText}`);
      }

      if (titleLink) {
  titleLink.className = 'event_internal_link related_article-title';
  titleLink.textContent = titleText;

  titleLink.setAttribute('href', ctaHref);
  titleLink.setAttribute('target', '_self');
  titleLink.setAttribute('role', 'link');
  titleLink.setAttribute('tabindex', '0');

  if (!titleLink.hasAttribute('data-focus-scroll-attached')) {
    titleLink.setAttribute('data-focus-scroll-attached', 'true');
    titleLink.addEventListener('focus', function() {
      this.style.outline = '2px solid #d69f13';
      this.style.outlineOffset = '2px';
      const headerHeight = document.getElementById('page-header')?.offsetHeight || 0;
      const elementRect = this.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const scrollPosition = absoluteElementTop - headerHeight - 50;
      window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
    });
    titleLink.addEventListener('blur', function() {
      this.style.outline = '';
      this.style.outlineOffset = '';
    });
  }

  if (titleText) {
    titleLink.setAttribute('data-action-detail', `LEARN MORE : ${titleText}`);
  }

  titleLink.onclick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (ctaHref && ctaHref !== '#') {
      window.location.href = ctaHref;
    }
  };

  titleLink.onkeydown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();

      if (ctaHref && ctaHref !== '#') {
        window.location.href = ctaHref;
      }
    }
  };
}

      const leftoverTitleNodes = element.querySelectorAll('.related_article-title, h3, .title');
      leftoverTitleNodes.forEach(node => {
        if (node !== titleLink && (!titleLink || !titleLink.contains(node))) {
          node.remove();
        }
      });

      let descriptionNode = element.querySelector('.related_article-description, p');
      if (descriptionNode && descriptionNode.tagName !== 'P') {
        const descriptionP = document.createElement('p');
        descriptionP.innerHTML = descriptionNode.innerHTML;
        descriptionP.className = 'related_article-description';
        descriptionNode.replaceWith(descriptionP);
        descriptionNode = descriptionP;
      }
      if (!descriptionNode && shortDescription) {
        descriptionNode = document.createElement('p');
        descriptionNode.className = 'related_article-description';
        descriptionNode.textContent = shortDescription;
      } else if (descriptionNode) {
        descriptionNode.classList.add('related_article-description');
        if (shortDescription) {
          descriptionNode.textContent = shortDescription;
        }
      }

      let ctaNode = element.querySelector('.related_article-button');
      if (!ctaNode && ctaHref) {
        ctaNode = document.createElement('a');
        ctaNode.className = 'related_article-button';
        ctaNode.textContent = ctaLabel;
      }
      if (ctaNode) {
  ctaNode.classList.add('related_article-button');
  ctaNode.textContent = ctaLabel;

  ctaNode.setAttribute('href', ctaHref);
  ctaNode.setAttribute('target', '_self');
  ctaNode.setAttribute('role', 'link');
  ctaNode.setAttribute('tabindex', '0');
  ctaNode.setAttribute('variant', 'simple');
  ctaNode.setAttribute('locale', locale);

  if (!ctaNode.hasAttribute('data-focus-scroll-attached')) {
    ctaNode.setAttribute('data-focus-scroll-attached', 'true');
    ctaNode.addEventListener('focus', function() {
      this.style.outline = '2px solid #d69f13';
      this.style.outlineOffset = '2px';
      const headerHeight = document.getElementById('page-header')?.offsetHeight || 0;
      const elementRect = this.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const scrollPosition = absoluteElementTop - headerHeight - 50;
      window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
    });
    ctaNode.addEventListener('blur', function() {
      this.style.outline = '';
      this.style.outlineOffset = '';
    });
  }

  ctaNode.onclick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (ctaHref && ctaHref !== '#') {
      window.location.href = ctaHref;
    }
  };

  ctaNode.onkeydown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();

      if (ctaHref && ctaHref !== '#') {
        window.location.href = ctaHref;
      }
    }
  };
}

      if (titleLink && titleLink.parentElement === element) {
        element.insertBefore(titleLink, element.firstChild);
      } else if (titleLink) {
        element.insertBefore(titleLink, element.firstChild);
      }

      if (descriptionNode) {
        element.appendChild(descriptionNode);
      }
      if (ctaNode) {
        element.appendChild(ctaNode);
      }
    });

    const prodWrappers = relatedRoot.querySelectorAll('.article_products');
    prodWrappers.forEach((w) => {
    if (w && w.getAttribute) {
        w.removeAttribute('tabindex');
    }
    });
  };

  checkArticle = () => {};

  stripTrailingSlash = url => {
    return url.endsWith('/') ? url.slice(0, -1) : url;
  };

  render() {
    const { articleData, router, pageContext } = this.props;
    const { thumbsUp, thumbsDown } = this.state;
    const articleDetailData = articleData?.articleCollection?.items?.[0];
    if (!articleDetailData) {
      return null;
    }

    const locale = (pageContext.locale || defaultLangKey).toLowerCase();
    const fallbackPath = `/${locale}/${articleDetailData.slug}`;
    const pagePath =
      this.stripTrailingSlash(pageContext.path || router.asPath || fallbackPath);
    const domainInfo = config.siteUrl;
    let path = domainInfo + pagePath;
    const constants = require(`../../constants/messages/${pageContext.locale}`);
    const relatedHeadingText = locale === 'es' ? 'MAS SOBRE EL TEMA' : 'MAIS COMO ESTE';
    const relatedData = articleDetailData;
    const isArticle = false;
    const articleSuspense = null;
    return (
      <React.Fragment>
        <Head>
          <link
            rel="preload"
            href={articleDetailData?.bannerImageCollection?.items[0]?.smartphoneImage &&
              articleDetailData?.bannerImageCollection?.items[0]?.smartphoneImage?.url ? getCdnImage(articleDetailData?.bannerImageCollection?.items[0]?.smartphoneImage?.url, { w: 2000, fm: 'webp' }) : ''}
            as="image"
          />
        </Head>
        {articleDetailData && articleDetailData.pageMetadata && (
          <PGDataLayer
            locale={pageContext.locale}
            pageType={contentType.articlePage}
            path={router.asPath}
            title={
              articleDetailData.pageMetadata &&
              articleDetailData.pageMetadata.pageTitle
            }
          />
        )}
        {articleDetailData && articleDetailData.pageMetadata && (
          <PageMetadata
            title={articleDetailData.pageMetadata.pageTitle}
            metaTitle={articleDetailData.pageMetadata.metaTitle}
            metaDescription={
              articleDetailData.pageMetadata.metaDescription &&
              articleDetailData.pageMetadata.metaDescription
            }
            orgTitle={
              articleDetailData.pageMetadata &&
              articleDetailData.pageMetadata.openGraphPageTitle
            }
            orgDescription={
              articleDetailData.pageMetadata &&
              articleDetailData.pageMetadata.openGraphDescription
            }
            orgType="article"
            orgImage={
              articleDetailData.pageMetadata.ogImage &&
              articleDetailData.pageMetadata.ogImage.url
            }
            twitterImage={
              articleDetailData.pageMetadata.ogImage &&
              articleDetailData.pageMetadata.ogImage.url
            }
            metaKeywords={
              articleDetailData.pageMetadata &&
              articleDetailData.pageMetadata.metaKeywords
            }
            twitterCard="summary_large_image"
          />
        )}
        <SEOArticle
          articleData={articleDetailData}
          locale={pageContext.locale}
          articleUrl={path}
        />
        <div className={classNames(styles.detailsPage.breadcrumbContainer)}>
          {(() => {
            const staticBreadcrumbs = [
              { link: `/${locale}`, linkText: constants.homeLabel },
              { link: pagePath, linkText: 'Blogue' },
              { link: pagePath, linkText: 'Sobre Nossos Produtos' },
              { link: pagePath, linkText: articleDetailData.title },
            ];
            return (
              <div className={breadcrumbStyles.breadcrumbMainDiv}>
                <GenericBreadcrumb className={classNames(breadcrumbStyles.breadcrumb_li.list_item)}>
                  {staticBreadcrumbs.map((item, index) => {
                    const showItemClass =
                      staticBreadcrumbs.length - 1 === index || staticBreadcrumbs.length - 2 === index
                        ? breadcrumbI18n.block
                        : breadcrumbI18n.hiddenmdinlineblock;
                    const lastItemClass =
                      staticBreadcrumbs.length - 1 === index ? breadcrumbI18n.fontbold : '';
                    return (
                      <BreadcrumbItem
                        key={index}
                        keyIndex={index}
                        component="li"
                        className={classNames(breadcrumbStyles.breadcrumb_li.list_li, showItemClass, lastItemClass)}
                        linkClassName={classNames(breadcrumbStyles.breadcrumb_li.list_link)}
                        to={item.link}
                        labelText={item.linkText}
                        separator="/"
                        active={staticBreadcrumbs.length === index + 1}
                      />
                    );
                  })}
                </GenericBreadcrumb>
              </div>
            );
          })()}
        </div>
        {articleDetailData && articleDetailData.variant === 'VideoArticle' && (
          <div className={styles.detailsPage.videoArticle.videoArticleWrapper}>
            <div
              className={styles.detailsPage.videoArticle.articleTitleWrapper}
            >
              <Typography
                component="h1"
                className={styles.detailsPage.videoArticle.articleTitle}
              >
                {articleDetailData.title}
              </Typography>
            </div>
            <div id="videoarticle">
              {getVideoCard(articleDetailData.videoArticle, articleDetailData.heroImage)}
            </div>
          </div>
        )}

        <div
          className={classNames(styles.detailsPage.socialShareArticle)}
          ref={this.ArticleRef}
        >
          <SocialShare
            shareIcon="Share"
            locale={pageContext.locale}
            shareImage={
              articleDetailData.pageMetadata &&
              articleDetailData.pageMetadata.ogImage &&
              articleDetailData.pageMetadata.ogImage.url
            }
            shareDescription={
              articleDetailData.pageMetadata &&
              articleDetailData.pageMetadata.openGraphDescription
            }
            template="article"
            productName={articleDetailData.title}
          />
          {articleDetailData && articleDetailData.variant !== 'Ingredient' && (
            <ThumbsUp
              recommendThisArticle={this.recommendThisArticle}
              thumbsUp={thumbsUp}
              thumbsDown={thumbsDown}
            />
          )}
        </div>
        
        <div className="article-layout">
          <div className="article-main">
            {articleDetailData &&
              articleDetailData.pageContentCollection &&
              articleDetailData.pageContentCollection.items.map(
                (sectionItem, index) => {
                  return (
                    <React.Fragment key={index}>
                      <LazyLoad offset={-50}>
                        <>
                          {renderSection(sectionItem, pageContext)}
                        </>
                      </LazyLoad>
                    </React.Fragment>
                  );
                }
              )}
          </div>

          {/* RIGHT SIDE: RELATED ARTICLES */}
          {isArticle ? (
            ''
          ) : relatedData &&
            relatedData.relatedArticlesCollection &&
            relatedData.relatedArticlesCollection.items.length > 0 ? (
            <aside
              ref={this.relatedRef}
              className={`article-related ${this.state.stopSidebarSticky ? 'stop-sticky' : ''}`}
            >
              <Suspense fallback={articleSuspense}>
                <div className={classNames(styles.detailsPage.moreOnThisTopic.mainWrapper)}>
                  <div className="related-article-heading">
                    <p><strong className="heading">{relatedHeadingText}</strong></p>
                  </div>
                  <div>
                    <ArticleCarousel
                      articleData={relatedData}
                      checkArticle={this.checkArticle}
                      locale={pageContext.locale}
                    />
                  </div>
                </div>
              </Suspense>
            </aside>
          ) : null}
        </div>

        {/* related products outside article-layout */}
        <div
          ref={this.faqRef}
          className={classNames(styles.detailsPage.hidingWrapper)}
        >
          {articleDetailData &&
            articleDetailData.relatedProductsCollection &&
            articleDetailData.relatedProductsCollection.items.length > 0 ? (
            <Suspense fallback={articleSuspense}>
              <div
                className={classNames(
                  styles.detailsPage.relatedProduct.mainWrapper
                )}
              >
                <div
                  className={classNames(
                    styles.detailsPage.relatedProduct.headingWrapper
                  )}
                >
                  <Typography
                    component="h3"
                    className={classNames(
                      styles.detailsPage.relatedProduct.heading
                    )}
                  >
                    {constants.recommendedProductHeading}
                  </Typography>
                </div>
                <ProductCarousel
                  product={articleDetailData}
                  locale={pageContext.locale}
                />
              </div>
            </Suspense>
          ) : null}
          <style jsx global>{`
                        .article-details-page .heroTitleId,
                        .article-details-page .heroTitleId:focus,
                        .article-details-page .heroTitleId:focus-visible,
                        .article-details-page h1.heroTitleId[tabindex],
                        .article-details-page h1.heroTitleId[tabindex]:focus,
                        .article-details-page h1.heroTitleId[tabindex]:focus-visible {
                            outline: none !important;
                            border: none !important;
                            box-shadow: none !important;
                        }

                        .article-details-page div.cms-article-heading[tabindex]:focus,
                        .article-details-page div.cms-article-heading[tabindex]:focus-visible,
                        .article-details-page div.cms-article-heading h1:focus,
                        .article-details-page div.cms-article-heading h1:focus-visible {
                            outline: none !important;
                            border: none !important;
                            box-shadow: none !important;
                        }

                    `}</style>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(ArticleDetail);

ArticleDetail.propTypes = {
};
ArticleDetail.defaultProps = {
};
